/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutSdkKeyViewsPathParams = NonNullable<operations['putSdkKeyViews']['parameters']['path']>;

export type PutSdkKeyViewsQueryParams = NonNullable<operations['putSdkKeyViews']['parameters']['query']>;

export type PutSdkKeyViewsRequestBody = OperationRequestBodyContent<operations['putSdkKeyViews']>;

export interface Input extends PutSdkKeyViewsPathParams {
  apiVersion?: string;
  query?: PutSdkKeyViewsQueryParams;
  body: PutSdkKeyViewsRequestBody;
  header: NonNullable<operations['putSdkKeyViews']['parameters']['header']>;
}

export async function putSdkKeyViews(
  { apiVersion, body, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/api/v2/projects/{projectKey}/environments/{environmentKey}/sdk-keys/{sdkKeyKey}/views', {
    params: { path, query, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
